module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d2/sec02_pc_4ba857e9627321cd7bf8e1d6ec01986b.jpg";